import { __awaiter, __generator, __values } from "tslib";
import { getShellShim } from '@office-start/shell-shim-service';
import { parseWorkload } from '../utilities/parseWorkload';
export function fetchThirdPartyWorkloads() {
    var _this = this;
    var shellShim;
    var token;
    return new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getShellShim()];
                case 1:
                    shellShim = _a.sent();
                    token = shellShim === null || shellShim === void 0 ? void 0 : shellShim.Apps.OnAppsUpdated(function (evt) {
                        var e_1, _a;
                        var parsedWorkloads = [];
                        if (evt.Apps) {
                            try {
                                for (var _b = __values(evt.Apps), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var app = _c.value;
                                    if (app.CollectorId !== 'FirstParty') {
                                        parsedWorkloads.push(parseWorkload(app));
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        resolve(parsedWorkloads);
                    });
                    return [2 /*return*/];
            }
        });
    }); }).finally(function () {
        if (token) {
            shellShim === null || shellShim === void 0 ? void 0 : shellShim.Apps.RemoveOnAppsUpdated(token);
        }
    });
}
//# sourceMappingURL=fetchThirdPartyWorkloads.js.map